import request from '@/utils/request'

// 新增购物车
export function getProductList(data) {
  return request({
    url: '/product/shopeeApi/list',
    method: 'GET',
    params: data
  })
}

// 新增购物车
export function unList(data) {
  return request({
    url: '/product/shopeeApi/unList',
    method: 'POST',
    data: data,
    params: data
  })
}
// 新增购物车
export function syncByShopShopee(data) {
  return request({
    url: '/product/shopeeApi/syncByShop',
    method: 'POST',
    data: data,
    params: data
  })
}
export function syncByIds(data) {
  return request({
    url: '/product/shopeeApi/syncByIds',
    method: 'POST',
    data: data,
    params: data
  })
}
// 新增购物车
export function batchUpdate(data) {
  return request({
    url: '/product/shopeeApi/batchUpdate',
    method: 'POST',
    data: data
  })
}

// 新增购物车
export function addProduct(data) {
  return request({
    url: '/product/shopeeApi/addProduct',
    method: 'POST',
    data: data
  })
}

// 新增购物车
export function addDraft(data) {
  return request({
    url: '/product/shopeeApi/addDraft',
    method: 'POST',
    data: data
  })
}
// 根据pid同步lazada产品
export function getCategoryAttributeAllShopee(data) {
  return request({
    url: '/product/shopeeApi/getAttr',
    method: 'GET',
    params: data
  })
}
// 草稿箱删除shopee产品
export function deletedraftProShopee(data) {
  return request({
    url: '/product/shopeeApi/delete',
    method: 'POST',
    params: data
  })
}
